export default [
  {
    title: 'Foundations',
    // icon: 'LayersIcon',
    icon: 'layer-group',
    children: [
      {
        title: 'Logos',
        route: 'foundations-logos',
      },
      {
        title: 'Typography',
        route: 'foundations-typography',
      },
      {
        title: 'Colors',
        route: 'foundations-colors',
      },
      {
        title: 'Spacing',
        route: 'foundations-spacing',
      },
      {
        title: 'Iconography',
        route: 'foundations-iconography',
      },
    ],
  },
]
